import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getThemeForUser } from '../slices/theme/thunk';
import { useCurrentUser } from '../slices/auth/hooks';
import { defaultTheme, setTheme } from '../slices/theme/reducer';
import Loading from '../Components/Loading';

const CustomThemeProvider = ({ children }) => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const globalTheme = useSelector(state => state.Theme);


    useEffect(() => {
        async function fetchTheme() {
            // if (!currentUser) return;

            try {
                const theme = await dispatch(getThemeForUser()).unwrap();

                dispatch(setTheme(theme));
            } catch (error) {
                console.error("Error fetching theme:", error);
                dispatch(setTheme(defaultTheme)); // Set to default or handle error
            }
        }

        fetchTheme();
    }, [dispatch, currentUser]);

    // Optional: if you want to repaint the body if theme changes
    // useEffect(() => {
    //   if (version > 0) {
    //     console.log("Theme updated to:", primaryColor);

    //     document.body.style.display = 'none';
    //     void document.body.offsetHeight;
    //     document.body.style.display = '';
    //   }
    // }, [version, primaryColor]);

    if (!globalTheme?.id && !globalTheme?.ownerId) {
        // return <div>Loading...</div>; // or a loading spinner
        return <Loading />
    }

    return <>{children}</>;
};

export default CustomThemeProvider;